import React from "react";
import { useTranslation } from "react-i18next";
import ClientHeader from "../../components/Client/ClientHeader";
import Footer from "../../components/Client/Footer";
import { useAuth } from "../../context/AuthContext";
import { useNotifications } from "../../context/NotificationsContext";
import "../../components/Client/clientTheme.css";
import "./Notifications.css";

function formatRelativeTime(value, t) {
  const diffMs = Date.now() - new Date(value).getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return t("justNow");
  if (diffMin < 60) return t("minutesAgo", { count: diffMin });
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return t("hoursAgo", { count: diffHours });
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return t("daysAgo", { count: diffDays });
  return new Date(value).toLocaleDateString();
}

export default function Notifications() {
  const { t } = useTranslation(["notifications", "common"]);
  const { isAuthenticated, openLoginModal } = useAuth();
  const { items, unreadCount, markRead, markAllRead } = useNotifications();

  return (
    <div className="client-notifications-page">
      <ClientHeader />

      <div className="client-notifications-content">
        <div className="client-notifications-header">
          <h1 className="client-notifications-title">{t("pageTitle")}</h1>
          {isAuthenticated && unreadCount > 0 && (
            <button type="button" className="client-notifications-mark-all-button" onClick={markAllRead}>
              {t("markAllReadButton")}
            </button>
          )}
        </div>

        {!isAuthenticated ? (
          <div className="client-notifications-empty">
            <p>{t("loginPrompt")}</p>
            <button type="button" className="client-notifications-login-button" onClick={openLoginModal}>
              {t("common:logIn")}
            </button>
          </div>
        ) : items.length === 0 ? (
          <div className="client-notifications-empty">
            <p>{t("emptyMessage")}</p>
          </div>
        ) : (
          <div className="client-notifications-list">
            {items.map((item) => (
              <button
                type="button"
                key={item.notificationId}
                className={`client-notification-row ${item.isRead ? "" : "unread"}`}
                onClick={() => !item.isRead && markRead(item.notificationId)}
              >
                <span className="client-notification-dot" />
                <span className="client-notification-body">
                  <span className="client-notification-title">{item.title}</span>
                  {item.body && <span className="client-notification-text">{item.body}</span>}
                  <span className="client-notification-time">{formatRelativeTime(item.createdAt, t)}</span>
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
